export const SHARED_CHAT_LINK_EXPIRED_KEY = 'SHARED_CHAT_LINK_EXPIRED_TEXT';
export const SHARED_CHAT_LINK_BROKEN_KEY = 'SHARED_CHAT_LINK_BROKEN_TEXT';

const SHARED_CHAT_EXPIRED_HTTP_STATUSES = new Set([401, 410]);

/**
 * Resolves the i18n key for a shared-chat load failure based on HTTP status.
 * 401/410 → expired link; all other failures → broken/unusable link.
 */
export function getSharedChatErrorMessageKey(status?: number): string {
  return status !== undefined && SHARED_CHAT_EXPIRED_HTTP_STATUSES.has(status)
    ? SHARED_CHAT_LINK_EXPIRED_KEY
    : SHARED_CHAT_LINK_BROKEN_KEY;
}
